class Popups {

  constructor() {

    if (!this.setVars())
      return

    this.setEvents()

  }

  setVars() {

    this.items = document.querySelectorAll('.popup')

    if (!this.items.length)
      return

    this.buttonsOpen  = document.querySelectorAll('*[data-popup-open]')
    this.currentPopup = null
    this.filesButtons = document.querySelectorAll('.popup__itemInput--file input')
    
    return true

  }

  setEvents() {

    document.body.addCustomEvent('open-popup', (index) => {
      this.openPopup(index)
    })

    this.buttonsOpen.each((item, value) => {

      item.addEventListener('click', (e) => {

        e.preventDefault()

        const index = e.currentTarget.getAttribute('data-popup-open')
        this.openPopup(index)        
      
      })

    })

    this.filesButtons.each((item, value) => {

      item.addEventListener('change', (e) => {
      
        const text     = item.parentNode.querySelector('.popup__itemFile')
        text.innerHTML = item.files[0] ? item.files[0].name : ''
      
      })

    })

  }

  openPopup(index) {

    const popup = document.querySelector('.popup[data-popup="' + index + '"]')

    if (!popup)
      return

    this.closePopup()

    if (!popup.hasClass('popup--noLock')) 
      Scroll.lock()

    popup.addClass('popup--active')

    const wrapper = popup.querySelector('.popup__wrapper')
    const cancel  = popup.querySelector('.popup__footerButton--cancel')

    popup.addEventListener('click', (e) => {
      this.closePopup()
    })

    wrapper.addEventListener('click', (e) => {
      e.stopPropagation()
    })
    
    const textareas = wrapper.querySelectorAll('textarea')

    textareas.each(textarea => {
      const observer = new MutationObserver(() => wrapper.SimpleBar && wrapper.SimpleBar.recalculate())

      observer.observe(textarea, {
        attributes: true,
      })
    })

    if (cancel) {

      cancel.addEventListener('click', (e) => {
        this.closePopup()
      })

    }

  }

  closePopup() {

    Scroll.unlock()
    this.items.removeClass('popup--active')

  }

}